module.exports = {
    extends: [
        '/',
        'base',
        'form',
        'relationship',
    ],
}